// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

// components
import { Image } from './styles';

// helpers
import { getAkamaiUrl } from 'shared/helpers/utils';

interface IBadgeProps {
  value?: Listing.IBadge;
  isDesktop: boolean;
}

const IMAGE_HEIGHT_DESKTOP = 20;
const IMAGE_HEIGHT_MOBILE = 16;

function Badge({ value, isDesktop }: IBadgeProps) {
  if (isEmpty(value) || !value.imageUrl) {
    return null;
  }

  const IMAGE_HEIGHT = isDesktop ? IMAGE_HEIGHT_DESKTOP : IMAGE_HEIGHT_MOBILE;

  const url = getAkamaiUrl(value.imageUrl, { height: IMAGE_HEIGHT * 2 });

  return (
    <Image
      src={url}
      height={IMAGE_HEIGHT}
      alt={value.title}
      data-test="badge"
      className="badge-img"
      loading="lazy"
    />
  );
}

export default memo(Badge);
